export default "__VITE_ASSET__BvlK5LD3__"